import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextLoop } from 'react-text-loop-next';
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
var cls = 'notice-bar';
var NoticeBar = function NoticeBar(_ref) {
  var className = _ref.className,
    id = _ref.id,
    pid = _ref.pid,
    config = _ref.config,
    _onClick = _ref.onClick,
    render = _ref.render;
  var list = config.list;
  var _useConfig = useConfig(),
    createNamespace = _useConfig.createNamespace,
    prefixCls = _useConfig.prefixCls;
  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), className);
  return _jsxs("div", Object.assign({
    className: classes,
    "data-componentid": id,
    "data-pid": pid
  }, {
    children: [_jsx("div", Object.assign({
      className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-icon", prefixCls))
    }, {
      children: _jsx("img", {
        src: "http://baleen-cdn-g.bybieyang.com/static/images/brandGame/ic_notice@2x.png",
        alt: ""
      })
    })), _jsx(TextLoop, Object.assign({
      interval: 2500,
      className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-group", prefixCls))
    }, {
      children: list === null || list === void 0 ? void 0 : list.map(function (item, index) {
        return _jsxs("div", Object.assign({
          className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-item", prefixCls)),
          onClick: function onClick() {
            return _onClick === null || _onClick === void 0 ? void 0 : _onClick({
              render: render,
              link: item.normallink,
              deeplink: item.deeplink,
              componentId: id,
              pid: pid
            });
          }
        }, {
          children: [_jsx("span", Object.assign({
            className: "text-overflow"
          }, {
            children: item.text
          })), (item.deeplink || item.normallink) && _jsx("img", {
            src: "http://baleen-cdn-g.bybieyang.com/static/images/brandGame/arrow.png",
            alt: ""
          })]
        }), index);
      })
    }))]
  }));
};
NoticeBar.displayName = 'NoticeBar';
NoticeBar.defaultProps = {
  config: {
    list: []
  }
};
export default NoticeBar;